import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, DropdownItem, DropdownMenu, Icon } from "semantic-ui-react";

import { DATE_FORMATS_FNS, Dropdown } from "components";
import { useGetDistrimateRecallStatusName } from "components/Recalls/utils";
import { formatDate } from "utils/dateHelperFunctions";

import type { RECALL_TYPE } from "components";
import type { RECALL_ENTITY_STATUSSES, RecallEntity } from "models";
import type { AddInterventionPayload } from "modules/AppointmentDetails/hooks";

type RecallRowProps = {
  label: string;
  selectOnly: boolean;
  recall: RecallEntity;
  recallType: RECALL_TYPE;
  allOptionSelected: boolean;
  endDate?: string | null;
  status?: RECALL_ENTITY_STATUSSES;
  isConvertButtonDisabled?: boolean;
  interventions?: AddInterventionPayload[];
  unselectAllOption: () => void;
  onConvertToIntervention: () => void;
  handleSelectionChange?: (recall: RecallEntity, recallType: RECALL_TYPE) => void;
};

export const OpenRecallRow = ({
  label,
  recall,
  status,
  endDate,
  recallType,
  selectOnly,
  interventions,
  allOptionSelected,
  isConvertButtonDisabled,
  unselectAllOption,
  handleSelectionChange,
  onConvertToIntervention
}: RecallRowProps) => {
  const { t } = useTranslation();

  const { getDistrimateRecallStatusName } = useGetDistrimateRecallStatusName();
  const isPreselected = Boolean(
    interventions?.some(intervention => [intervention.rdw_recall_id, intervention.pon_recall_id, intervention.recalls_id].includes(recall.id))
  );
  const [isSelected, setIsSelected] = useState(isPreselected);

  useEffect(() => {
    if (!isPreselected) setIsSelected(allOptionSelected);
  }, [allOptionSelected]);

  return (
    <div className={`OpenRecalls-item OpenRecalls-layout${selectOnly ? "-2" : "-3"}`}>
      {selectOnly && handleSelectionChange && (
        <div className="OpenRecalls-checkbox">
          <Checkbox
            defaultChecked={isSelected}
            checked={isSelected}
            disabled={isPreselected}
            className="OpenRecalls-item-checkbox"
            onChange={(_, { checked }) => {
              setIsSelected(Boolean(checked));
              unselectAllOption();
              handleSelectionChange(recall, recallType);
            }}
          />
        </div>
      )}
      <span>{label}</span>

      {status && !selectOnly && <span>{getDistrimateRecallStatusName(status)}</span>}
      {endDate && <span>{formatDate(endDate, DATE_FORMATS_FNS.dateMonthYear)}</span>}
      {!endDate && selectOnly && <div className="OpenRecalls-filler"></div>}

      {!selectOnly && (
        <Dropdown
          className="OpenRecalls-dropdown"
          floating
          icon={null}
          direction="left"
          trigger={<Icon className={`${isConvertButtonDisabled ? "link horizontal" : "plus"} grey`} />}
        >
          {!isConvertButtonDisabled ? (
            <DropdownMenu>
              <DropdownItem onClick={onConvertToIntervention}>
                <Icon className="screwdriver wrench" />
                <span>{t("v8_convert_to_intervention", "Convert to Intervention")}</span>
              </DropdownItem>
            </DropdownMenu>
          ) : null}
        </Dropdown>
      )}
    </div>
  );
};
